import React from 'react'

const PreventUnderZLayerInteraction = ({ zIndex=1300 }) => {
      return (
        <div role='presentation' style={{position:'fixed', zIndex: zIndex, inset:"0px"}}/>
    )
}

export default PreventUnderZLayerInteraction